import { configureStore } from "@reduxjs/toolkit";
import userinfoReducer from "./userInfoSlice";

const store = configureStore({
  reducer: {
    userInfo: userinfoReducer,
  },
});

export { store };